var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/categories"}},[_c('div',{staticClass:"page"},[_c('video',{attrs:{"src":require("@/assets/video/GGDB_DREAMWALL_LOOP.mp4"),"type":"video/mp4","loop":"","autoplay":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }